import { ApiService } from '@/services/api/ApiService';
import {
  PrintOrder,
  SendPrintOrderParams,
  UpdatePrintOrderParams,
} from '@/types/activation/print-order';

export class PrintOrderService {
  static async getOrCreate(activationPackId: string, forceNew = false): Promise<PrintOrder | null> {
    try {
      const response = await ApiService.invoke<{ printOrder: PrintOrder }>({
        resource: 'print-orders',
        action: 'get-or-create',
        data: { activation_pack_id: activationPackId, forceNew },
      });
      return response?.printOrder ?? null;
    } catch (error) {
      console.error('Error fetching/creating print order:', error);
      throw error;
    }
  }

  static async updateOrder(
    orderId: string,
    updates: UpdatePrintOrderParams,
    expectedAssetInputRevision?: string,
    expectedUpdatedAt?: string,
  ): Promise<PrintOrder | null> {
    try {
      const response = await ApiService.invoke<{ printOrder: PrintOrder }>({
        resource: 'print-orders',
        action: 'update',
        id: orderId,
        data: {
          ...updates,
          ...(expectedAssetInputRevision
            ? { expectedAssetInputRevision }
            : {}),
          ...(expectedUpdatedAt ? { expectedUpdatedAt } : {}),
        },
      });
      return response?.printOrder ?? null;
    } catch (error) {
      console.error('Error updating print order:', error);
      throw error;
    }
  }

  static async sendOrder(orderId: string, params: SendPrintOrderParams): Promise<PrintOrder | null> {
    try {
      const response = await ApiService.invoke<{ printOrder: PrintOrder }>({
        resource: 'print-orders',
        action: 'send',
        id: orderId,
        data: {
          vendorEmail: params.vendorEmail,
          notes: params.notes,
          expectedUpdatedAt: params.expectedUpdatedAt,
        },
      });
      return response?.printOrder ?? null;
    } catch (error) {
      console.error('Error sending print order:', error);
      throw error;
    }
  }
}
